'use client';
import { Suspense } from 'react';
import BottomNav from './BottomNav';

export default function BottomNavWrapper() {
  return (
    <Suspense fallback={null}>
      <BottomNav />
    </Suspense>
  );
}
